import { NavLink as RouterNavLink, type NavLinkProps } from "react-router-dom";
import { cn } from "../../lib/cn";

type Props = Omit<NavLinkProps, "className"> & { children: React.ReactNode };

export default function NavLink({ children, ...props }: Props) {
  return (
    <RouterNavLink
      {...props}
      className={({ isActive }) =>
        cn(
          "relative px-1 py-1.5 text-sm font-medium transition-colors duration-150",
          "focus:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded",
          "after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-full after:rounded-full after:transition-all after:duration-150",
          isActive
            ? "text-primary after:bg-primary"
            : "text-ink-secondary hover:text-ink after:bg-transparent"
        )
      }
    >
      {children}
    </RouterNavLink>
  );
}
